type FileSizeOutputFormatOptions = "TB" | "GB" | "MB" | "KB";

export const fileSizeToString = (fileSizeInByte: number, outputSize?: FileSizeOutputFormatOptions): string => {
  fileSizeInByte = fileSizeInByte || 0;

  const byteFactor = 1000;
  if (!outputSize) {
    if (fileSizeInByte >= Math.pow(byteFactor, 4)) {
      return fileSizeWithOutputFormat(fileSizeInByte, "TB");
    } else if (fileSizeInByte >= Math.pow(byteFactor, 3)) {
      return fileSizeWithOutputFormat(fileSizeInByte, "GB");
    } else if (fileSizeInByte >= Math.pow(byteFactor, 2)) {
      return fileSizeWithOutputFormat(fileSizeInByte, "MB");
    } else if (fileSizeInByte >= byteFactor) {
      return fileSizeWithOutputFormat(fileSizeInByte, "KB");
    }

    return fileSizeInByte.toFixed(2) + " B";
  } else {
    return fileSizeWithOutputFormat(fileSizeInByte, outputSize);
  }
};

const fileSizeWithOutputFormat = (fileSizeInByte: number, outputSize: FileSizeOutputFormatOptions): string => {
  const byteFactor = 1000;

  switch (outputSize) {
    case "TB":
      return `${(fileSizeInByte / Math.pow(byteFactor, 4)).toFixed(2)} TB`;
    case "GB":
      return `${(fileSizeInByte / Math.pow(byteFactor, 3)).toFixed(2)} GB`;
    case "MB":
      return `${(fileSizeInByte / Math.pow(byteFactor, 2)).toFixed(2)} MB`;
    case "KB":
      return `${(fileSizeInByte / byteFactor).toFixed(2)} KB`;
    default:
      return `${fileSizeInByte.toFixed(2)} B`;
  }
};
